var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('Grid',{attrs:{"name":"DsrCodesGrid","url":_vm.url,"columns":_vm.columns,"pageable":false,"filterable":true,"sortable":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }